/* tslint:disable */
/* eslint-disable */
/**
 * User Config Service API
 * Server-side storage for OpenField client configuration: the UI state that currently lives in the browser\'s `localStorage` (effort colours, saved report items, recent colours, panel sort order, ...), so it survives a cache clear and follows a user between browsers and devices.  **SCAFFOLDING:** the `/settings` resource below is a placeholder CRUD surface used to stand the service up end to end. The real key namespaces, value shapes and any per-key schema are still to be designed. See \"Open decisions\" in AGENTS.md.  **Model:** a setting is an opaque JSON value stored under a string key, scoped to the caller\'s account. Values are stored and returned verbatim; the service does not interpret them.  **Identity:** the caller\'s account comes from the gateway-verified JWT. Config is currently scoped to the account only. The shared JWT authorizer does not yet emit a user identity, so per-user scoping is an open decision (see AGENTS.md). 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from "./configuration";
// Some imports not used depending on template conditions
// @ts-ignore
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';

export const BASE_PATH = "http://localhost:3300".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface RequestArgs
 */
export interface RequestArgs {
    url: string;
    options: AxiosRequestConfig;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError" = "RequiredError";
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}
